import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrCrewService } from '@app/services/sr-crew.service';
import { SrResourceGet, SrResourceService } from '@app/services/sr-resource.service';

@Component({
    selector: 'tt-sr-resource',
    templateUrl: './sr-resource.component.html',
    styleUrls: ['./sr-resource.component.css'],
    standalone: false,
})
export class SrResourceComponent implements OnInit {
    public page?: SrResourceGet;
    public subResources: Item[] = [];
    public saving = false;
    public calculating = false;
    public error = '';

    constructor(private readonly resources: SrResourceService, private readonly crew: SrCrewService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.resources.getResource({ resource_id_belongto: String(this.navigator?.params['resource_id_belongto'] ?? ''), resource_id: String(this.navigator?.params['resource_id'] ?? '') });
            if (this.page.main_resource_id?.trim()) {
                this.subResources = [];
                this.subResources = await this.crew.getSubResources({ main_resource_id: this.page.main_resource_id });
            }
        } catch (error) { this.showError(error); }
    }

    public async calculateFrrId(): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try {
            const value: unknown = await this.modal.showCalculator('frr_id', undefined, this.page.frr_id);
            if (typeof value === 'string' || typeof value === 'number') this.page.frr_id = value;
        } catch (error) { this.showError(error); }
        finally { this.calculating = false; }
    }

    public async save(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        this.error = '';
        try {
            const response = await this.resources.saveResource(this.page);
            if (response.errorcode !== '0') {
                await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage,
                    buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            } else {
                this.saving = false;
                await this.navigator?.back();
            }
        } catch (error) { this.showError(error); }
        finally { this.saving = false; }
    }

    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
